<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: '',
      uniformNum: '',
      phone: ''
    };
  },
  components: {}
};
</script>
